import { t } from 'i18next';
import React, { useReducer } from 'react'
import { getAccessEquipmentsService } from '../../services/accessEquipment';
import AccessEquipmentContext from './AccessEquipmentContext'
import AccessEquipmentReducer from './AccessEquipmentReducer';
import { logout } from '../../services/login';

const AccessEquipmentState = ({ children }) => {

    const initialState = {
        equipments: [],
        error: false,
        message: '',
        accessEquipmentsSelected: [],
        accessEquipment: {
            id: null,
            details: '',
        }
    };

    const [state, dispatch] = useReducer(AccessEquipmentReducer, initialState);

    const cleanAccessEquipmentState = () => dispatch({ type: 'CLEAN' });

    const setAccessEquipmentsSelected = (accessEquipmentsSelected) => {
        dispatch({
            type: 'SET_ACCESS_EQUIPMENTS_SELECTED',
            payload: accessEquipmentsSelected
        })
    }

    const setAccessEquipment = (accessEquipment) => {
        dispatch({
            type: 'SET_ACCESS_EQUIPMENT',
            payload: accessEquipment
        })
    }

    const getAccessEquipments = async () => {
        try {
            const { data, ok } = await getAccessEquipmentsService();
            if (ok) {
                dispatch({
                    type: 'GET_EQUIPMENTS',
                    payload: data.response
                })
            } else {
                const { error_code } = await data.json();
                switch (error_code) {
                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('TOKEN_ERROR')
                        })
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        dispatch({
                            type: 'ERROR_SERVER',
                            payload: t('ERROR_TRY_AGAIN')
                        })
                        break;
                }
            }
        } catch (e) {
            console.log(e);
            dispatch({
                type: 'ERROR_SERVER',
                payload: t('SERVER_ERROR')
            });
        }
    }

    return (
        <AccessEquipmentContext.Provider
            value={{
                accessEquipmentState: state,
                getAccessEquipments,
                setAccessEquipmentsSelected,
                cleanAccessEquipmentState,
                setAccessEquipment,
            }}
        >
            {children}
        </AccessEquipmentContext.Provider>
    )
}

export default AccessEquipmentState